import { ParameterMetadata, ParameterType, PrimitiveType } from '../../../api/api';
import { JsonSchemaModel } from '../Models/JsonSchemaModel';
import { convertJsonSchemaPropertyToEntityProperty } from './EntityMetadataModelConverter';
import { getNonNullSchema } from './JsonSchemaTypes';

/** Preserve the full contract for the schema-aware editor; derive only unambiguous display hints. */
export function getAgentToolInputParameters(schema: JsonSchemaModel): ParameterMetadata[] {
	return Object.entries(schema.properties ?? {}).map(([name, property], order) => {
		const nonNull = getNonNullSchema(property);
		const propertyType = convertJsonSchemaPropertyToEntityProperty(name, property, schema.required?.includes(name) ?? false);
		const type =
			typeof nonNull.type === 'string'
				? nonNull.type === 'array'
					? PrimitiveType.Collection
					: nonNull.type === 'null'
						? undefined
						: propertyType.type
				: undefined;
		return {
			name,
			displayName: name,
			description: property.description,
			type: ParameterType.Expression,
			categories: [],
			// The override itself is optional, even if the effective tool input is required.
			isRequired: false,
			isCollection: false,
			expectedType: { type, typeJsonSchema: property },
			valueOptions: nonNull.enum?.filter((value) => value !== null).map((value) => ({ name: String(value), value })),
			order,
		};
	});
}
